import {Injectable} from "@angular/core";
import {SearchScopeEnum} from "../../../shared/enums/search-scope.enum";
import {EmptySearchParamsFilterModel} from "../../../shared/models/search/params/filters/empty-search-params-filter.model";
import {QueryStringSerializationService} from "../../../shared/services/query-string-serialization.service";
import { ProductParamsFilterFactoryServices } from "../../components/tabs/products-tab/services/factories/product-params-filter-factory.services";
import {ContentSearchParamsModel} from "../../models/search-params/content-search-params.model";
import {ContentSearchConfigService} from "../content-search-config.service";
import {ProductsParamsFilter} from "../../models/search-params/filters/products-params-filter";

@Injectable({
    providedIn: "root"
})
export class ContentSearchParamsFactoryService {
    public constructor(
        private productParamsFilterFactoryServices: ProductParamsFilterFactoryServices,
        private queryStringSerializationService: QueryStringSerializationService,
        private configService: ContentSearchConfigService
    ) {
    }

    public createParamsByQueryString(queryString: string): ContentSearchParamsModel {
        queryString = queryString || "";

        const searchParamsData = this.queryStringSerializationService.deserialize<ContentSearchParamsModel>(queryString);

        const searchScope = Object.keys(SearchScopeEnum).map(x => SearchScopeEnum[x]).indexOf(searchParamsData.searchScope) > -1 // be safe
            ? searchParamsData.searchScope
            : this.configService.getDefaultScope();
        const searchText = searchParamsData.searchText ? decodeURIComponent(searchParamsData.searchText).replace(/\+/g, " "): "";
        const pageNumber = searchParamsData.pageNumber > 0 ? +searchParamsData.pageNumber : 1;
        const filter = this.createFilter(searchScope, searchParamsData.filter, searchText);

        let forcedSorting = false;
        if (searchScope === SearchScopeEnum.Product) {
            const sourceParams = searchParamsData.filter as ProductsParamsFilter;
            forcedSorting = (!!sourceParams && !!sourceParams.sorting);
        }

        const searchParams = new ContentSearchParamsModel(searchScope, searchText, forcedSorting, pageNumber, filter);

        return searchParams;
    }

    public createFilter(scope: SearchScopeEnum, initialState: EmptySearchParamsFilterModel = null, searchText: string = null): EmptySearchParamsFilterModel {
        initialState = initialState || {} as EmptySearchParamsFilterModel;

        let filter: EmptySearchParamsFilterModel;

        switch (scope) {
            case SearchScopeEnum.Product: {
                filter = this.productParamsFilterFactoryServices.createFilter(initialState, searchText);
                break;
            }
            case SearchScopeEnum.Media: {
                filter = new EmptySearchParamsFilterModel();
                break;
            }
            case SearchScopeEnum.Service: {
                filter = new EmptySearchParamsFilterModel();
                break;
            }
            case SearchScopeEnum.Other: {
                filter = new EmptySearchParamsFilterModel();
                break;
            }
            default:
                throw new Error("Unknown search scope.");
        }

        return filter;
    }

    public serialiseToQueryString(searchParams: ContentSearchParamsModel): string {
        return this.queryStringSerializationService.serialize(searchParams);
    }
}
